interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`bg-surface py-20 lg:py-28 ${className}`}>
      <div className="mx-auto px-6 lg:px-12 max-w-7xl">
        <div className="max-w-4xl">
          <div className="flex items-center space-x-3 mb-6">
            <div className="h-1 w-12 bg-accent"></div>
            <span className="font-accent text-sm text-text-secondary uppercase tracking-wider">
              Infrastructure-First Approach
            </span>
          </div>
          
          <h1 className="font-headline font-bold text-4xl lg:text-5xl xl:text-6xl text-primary mb-6 leading-tight">
            Infrastructure, Not Promises
          </h1>
          
          <p className="font-body text-lg lg:text-xl text-text-secondary leading-relaxed mb-8">
            We are the Goldman Sachs of ad infrastructure. While others sell performance dreams, we build the reliable systems that make professional advertising possible at scale.
          </p>
          
          <div className="flex flex-wrap gap-4">
            <div className="flex items-center space-x-2 px-4 py-2 bg-success/10 rounded-sm">
              <div className="w-2 h-2 bg-success rounded-full"></div>
              <span className="font-body text-sm text-text-primary">
                Hong Kong Incorporated
              </span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 bg-accent/10 rounded-sm">
              <div className="w-2 h-2 bg-accent rounded-full"></div>
              <span className="font-body text-sm text-text-primary">
                Compliance-Led Operations
              </span>
            </div>
            <div className="flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-sm">
              <div className="w-2 h-2 bg-primary rounded-full"></div>
              <span className="font-body text-sm text-text-primary">
                Built for Professionals
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;